module.exports = __webpack_public_path__ + "img/2026big5.0b1a5cca.png";